import {Coordinates} from '../types/coordinates'

export const filterUndefinedCoordinates = <T extends {coordinates: Coordinates}>(
  list: Array<Omit<T, 'coordinates'> & Partial<Pick<T, 'coordinates'>>>,
): T[] => list.filter((v) => v.coordinates !== undefined) as Required<T>[]
